// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : INTEREST WAIVER ADDED
// MODFIED DATA : 19-08-2025

const AutoLoanCollectionTypes = {
	/** ***************** FETCH AUTO LOAN INDEX LIST START *********************** */
	FETCH_AUTO_LOAN_INDEX_LIST_START: 'fetch_auto_loan_index_list_start',
	FETCH_AUTO_LOAN_INDEX_LIST_SUCCESS: 'fetch_auto_loan_index_list_success',
	FETCH_AUTO_LOAN_INDEX_LIST_FAILURE: 'fetch_auto_loan_index_list_failure',
	FETCH_AUTO_LOAN_INDEX_LIST_RESPONSE_RESET: 'fetch_auto_loan_index_list_reponse_reset',
	FETCH_AUTO_LOAN_INDEX_LIST_RESPONSE_CHANGED: 'fetch_auto_loan_index_list_response_changed',
	/** ***************** FETCH AUTO LOAN INDEX LIST END *********************** */

	/** ***************** FETCH AUTO LOAN COLLECTION LIST START *********************** */
	FETCH_AUTO_LOAN_COLLECTION_LIST_START: 'fetch_auto_loan_collection_list_start',
	FETCH_AUTO_LOAN_COLLECTION_LIST_SUCCESS: 'fetch_auto_loan_collection_list_success',
	FETCH_AUTO_LOAN_COLLECTION_LIST_FAILURE: 'fetch_auto_loan_collection_list_failure',
	FETCH_AUTO_LOAN_COLLECTION_LIST_RESPONSE_RESET: 'fetch_auto_loan_collection_list_reponse_reset',
	FETCH_AUTO_LOAN_COLLECTION_LIST_RESPONSE_CHANGED:
		'fetch_auto_loan_collection_list_response_changed',
	/** ***************** FETCH AUTO LOAN COLLECTION LIST END *********************** */

	/** ***************** UPDATE AUTO LOAN COLLECTION LIST START *********************** */
	UPDATE_AUTO_LOAN_COLLECTION_START: 'update_auto_loan_collection_start',
	UPDATE_AUTO_LOAN_COLLECTION_SUCCESS: 'update_auto_loan_collection_success',
	UPDATE_AUTO_LOAN_COLLECTION_FAILURE: 'update_auto_loan_collection_failure',
	UPDATE_AUTO_LOAN_COLLECTION_RESPONSE_RESET_START:
		'update_auto_loan_collection_response_reset_start',
	UPDATE_AUTO_LOAN_COLLECTION_RESPONSE_CHANGED: 'update_auto_loan_collection_response_changed',
	/** ***************** UPDATE AUTO LOAN COLLECTION LIST END *********************** */

	/** ***************** REVERT AUTO LOAN COLLECTION LIST START *********************** */
	REVERT_AUTO_LOAN_COLLECTION_START: 'revert_auto_loan_collection_start',
	REVERT_AUTO_LOAN_COLLECTION_SUCCESS: 'revert_auto_loan_collection_success',
	REVERT_AUTO_LOAN_COLLECTION_FAILURE: 'revert_auto_loan_collection_failure',
	REVERT_AUTO_LOAN_COLLECTION_RESPONSE_RESET_START:
		'revert_auto_loan_collection_response_reset_start',
	REVERT_AUTO_LOAN_COLLECTION_RESPONSE_CHANGED: 'revert_auto_loan_collection_response_changed',
	/** ***************** REVERT AUTO LOAN COLLECTION LIST START *********************** */

	/** ***************** REVERT AUTO LOAN MEMBER WALLLET START *********************** */
	REVERT_AUTO_LOAN_MEMBER_WALLET_START: 'revert_auto_loan_member_wallet_start',
	REVERT_AUTO_LOAN_MEMBER_WALLET_SUCCESS: 'revert_auto_loan_member_wallet_sucess',
	REVERT_AUTO_LOAN_MEMBER_WALLET_FAILURE: 'revert_auto_loan_member_wallet_failure',
	REVERT_AUTO_LOAN_MEMBER_WALLET_RESPONSE_RESET_START:
		'revert_auto_loan_member_wallet_response_reset_start',
	REVERT_AUTO_LOAN_MEMBER_WALLET_RESPONSE_CHANGED:
		'revert_auto_loan_member_wallet_response_changed',
	/** ***************** REVERT AUTO LOAN MEMBER WALLLET END *********************** */

	/** ***************** UPDATE AUTO LOAN INTEREST WAIVER  START *********************** */
	UPDATE_AUTO_LOAN_INTEREST_WAIVER_START: 'update_auto_loan_interest_waiver_start',
	UPDATE_AUTO_LOAN_INTEREST_WAIVER_SUCCESS: 'UPDATE_AUTO_LOAN_INTEREST_WAIVER_SUCCESS',
	UPDATE_AUTO_LOAN_INTEREST_WAIVER_FAILURE: 'UPDATE_AUTO_LOAN_INTEREST_WAIVER_FAILURE',
	UPDATE_AUTO_LOAN_INTEREST_WAIVER_RESPONSE_RESET:
		'UPDATE_AUTO_LOAN_INTEREST_WAIVER_RESPONSE_RESET',
	UPDATE_AUTO_LOAN_INTEREST_WAIVER_RESPONSE_CHANGED:
		'UPDATE_AUTO_LOAN_INTEREST_WAIVER_RESPONSE_CHANGED',
	/** ***************** UPDATE AUTO LOAN INTEREST WAIVER END *********************** */

	/************************ AUTO LOAN COLLECTION APPROVAL START ****************** */
	AUTO_LOAN_COLLECTION_APPROVAL_START: 'auto_loan_collection_approval_start',
	AUTO_LOAN_COLLECTION_APPROVAL_SUCCESS: 'auto_loan_collection_approval_success',
	AUTO_LOAN_COLLECTION_APPROVAL_FAILURE: 'auto_loan_collection_approval_failure',
	AUTO_LOAN_COLLECTION_APPROVAL_RESPONSE_RESET: 'auto_loan_collection_approval_response_reset',
	AUTO_LOAN_COLLECTION_APPROVAL_RESPONSE_CHANGED:
		'auto_loan_collection_approval_response_changed',
	/************************ AUTO LOAN COLLECTION APPROVAL END ****************** */

	/************************ AUTO LOAN COLLECTION VEHICLE SEIZED START *******************/
	AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_START: 'auto_loan_collection_vehicle_seized_start',
	AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_SUCCESS: 'auto_loan_collection_vehicle_seized_success',
	AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_FAILURE: 'auto_loan_collection_vehicle_seized_failure',
	AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_RESPONSE_RESET:
		'auto_loan_collection_vehicle_seized_response_reset',
	AUTO_LOAN_COLLECTION_VEHICLE_SEIZED_RESPONSE_CHANGED:
		'auto_loan_collection_vehicle_seized_response_changed',
	/************************ AUTO LOAN COLLECTION VEHICLE SEIZED END *******************/

	/************************ ADD AUTO LOAN MEMBER WALLET START *******************/
	ADD_AUTO_LOAN_MEMBER_WALLET_START: 'add_auto_loan_member_wallet_start',
	ADD_AUTO_LOAN_MEMBER_WALLET_SUCCESS: 'add_auto_loan_member_wallet_success',
	ADD_AUTO_LOAN_MEMBER_WALLET_FAILURE: 'add_auto_loan_member_wallet_failure',
	ADD_AUTO_LOAN_MEMBER_WALLET_RESPONSE_RESET_START:
		'add_auto_loan_member_wallet_response_reset_start',
	ADD_AUTO_LOAN_MEMBER_WALLET_RESPONSE_CHANGED: 'add_auto_loan_member_wallet_response_changed',
	/************************ ADD AUTO LOAN MEMBER WALLET END *******************/

	/************************ FETCH AUTO LOAN REPAYMENT START *******************/
	FETCH_AUTO_LOAN_REPAYMENT_START: 'FETCH_AUTO_LOAN_REPAYMENT_START',
	FETCH_AUTO_LOAN_REPAYMENT_SUCCESS: 'FETCH_AUTO_LOAN_REPAYMENT_SUCCESS',
	FETCH_AUTO_LOAN_REPAYMENT_FAILURE: 'FETCH_AUTO_LOAN_REPAYMENT_FAILURE',
	FETCH_AUTO_LOAN_REPAYMENT_RESPONSE_RESET: 'FETCH_AUTO_LOAN_REPAYMENT_RESPONSE_RESET',
	FETCH_AUTO_LOAN_REPAYMENT_RESPONSE_CHANGED: 'FETCH_AUTO_LOAN_REPAYMENT_RESPONSE_CHANGED',
	/************************ FETCH AUTO LOAN REPAYMENT END *******************/
	/************************ FETCH AUTO LOAN ARREAR COLLECTIONS START *******************/
	FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_START: 'FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_START',
	FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_SUCCESS: 'FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_SUCCESS',
	FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_FAILURE: 'FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_FAILURE',
	FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_RESPONSE_RESET:
		'FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_RESPONSE_RESET',
	FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_RESPONSE_CHANGED:
		'FETCH_AUTO_LOAN_ARREAR_COLLECTIONS_RESPONSE_CHANGED',
	/************************ FETCH AUTO LOAN ARREAR COLLECTIONS END *******************/

	/************************ FETCH AUTO LOAN VEHICLE DETAILS START *******************/
	FETCH_AUTO_LOAN_VEHICLE_DETAILS_START: 'FETCH_AUTO_LOAN_VEHICLE_DETAILS_START',
	FETCH_AUTO_LOAN_VEHICLE_DETAILS_SUCCESS: 'FETCH_AUTO_LOAN_VEHICLE_DETAILS_SUCCESS',
	FETCH_AUTO_LOAN_VEHICLE_DETAILS_FAILURE: 'FETCH_AUTO_LOAN_VEHICLE_DETAILS_FAILURE',
	FETCH_AUTO_LOAN_VEHICLE_DETAILS_RESPONSE_RESET:
		'FETCH_AUTO_LOAN_VEHICLE_DETAILS_RESPONSE_RESET',
	FETCH_AUTO_LOAN_VEHICLE_DETAILS_RESPONSE_CHANGED:
		'FETCH_AUTO_LOAN_VEHICLE_DETAILS_RESPONSE_CHANGED',
	/************************ FETCH AUTO LOAN VEHICLE DETAILS END *******************/
};
export default AutoLoanCollectionTypes;
